import { Box, Container, CircularProgress } from '@mui/material';
// import { Camera } from '../../core/global/Icons';
// import { PhotoLoader  } from '../../core/loader/PhotoLoader';
// import Addphoto from "../../assets/images/assetLogo/addphoto.png";

export const Photo = ({tool_state, profile_state}) => {
    const pinfo = tool_state.__SESSION.data.pinfo[0]
    const ps = profile_state
    
    return (
        <Container>
            <Box display="flex" justifyContent="center" width="100%" height="100%" sx={{backgroundImage: `url(${ 
                JSON.parse(pinfo.profile).cover === null || JSON.parse(pinfo.profile).cover === '' ? 
                    'https://pofsis-business.s3.amazonaws.com/biz-image/1654651177613.jpg' 
                    : JSON.parse(pinfo.profile).cover
                })`, 
                backgroundSize:"cover", 
                backgroundPosition:"center center", 
                opacity:ps.isLoader.data.type === 'cover' && ps.isLoader.data.status ? 0.8 : 1, 
                height:'347px', minHeight:'347px', mb: "30px" }} 
            >
                <Box display="flex" justifyContent="center" width="100%" height="100%" sx={{background: 'linear-gradient(#ffffff00, #00000052)', backgroundSize:"cover", backgroundPosition:"center center", 
                    opacity:ps.isLoader.data.type === 'cover' && ps.isLoader.data.status ? 0.8 : 1,
                height:'347px', minHeight:'347px' }} 
                >
                    <Box component={Container} width="100%" mx={{sm:3, lg:0}}  >
                        <Box width="100%" height="100%" color="#ffffff" display="flex" justifyContent="center" alignItems="center">
                            {ps.isLoader.data.type === 'cover' && ps.isLoader.data.status  && (
                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                    <CircularProgress size={150} variant="determinate" value={ps.isProgress.data} sx={{bgcolor:'#ffffff', opacity:0.5, borderRadius:'100%'}}/>
                                    <Box sx={{top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center',}} >
                                        <Box fontSize={12} component="strong"> {`${Math.round(ps.isProgress.data)}%`} </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>
                        <Box textAlign="center" width="100%" height="100%" ml={2} display="flex" justifyContent="space-between">
                            <Box display="flex" position="relative" top="-95px">
                                <Box display="flex" alignItems= "center" flexDirection= "column" mr={2}>
                                    <Box borderRadius="32px" border="solid 3px" borderColor="#0000" overflow="hidden" className="personal-logo-md personal-logo-flat-top " sx={{backgroundImage: `url(${
                                            JSON.parse(pinfo.profile).profile === null || JSON.parse(pinfo.profile).profile === '' ? 
                                            'https://pofsis-business.s3.amazonaws.com/biz-image/1653891687343.jpg' 
                                            : JSON.parse(pinfo.profile).profile 
                                        })`, 
                                        width:'120px !important', height:'120px important', 
                                        opacity:ps.isLoader.data.type === 'profile' && ps.isLoader.data.status ? 0.8 : 1,
                                        }}>
                                        <Box height="100%" width="100%" display="flex" flexDirection="column" 
                                            justifyContent={
                                                ps.isLoader.data.type === 'profile' && ps.isLoader.data.status ? 
                                                'center' 
                                                : 
                                                "flex-end"
                                            } 
                                            alignItems={
                                                ps.isLoader.data.type === 'profile' && ps.isLoader.data.status ? 
                                                'center' 
                                                : 
                                                "flex-end"
                                            }
                                            pr={.5} 
                                            pb={.5}
                                        >
                                        {/* {ps.isLoader.data.type === 'profile' && ps.isLoader.data.status ? 
                                            <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                                <CircularProgress size={60} variant="determinate" value={ps.isProgress.data} sx={{bgcolor:'#ffffff', opacity:0.5, borderRadius:'100%'}}/>
                                                <Box sx={{top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center',}} >
                                                    <Box fontSize={12} component="strong"> {`${Math.round(ps.isProgress.data)}%`} </Box>
                                                </Box>
                                            </Box>
                                        :
                                            <>
                                                <input accept="image/*" disabled={ps.isLoader.data.status ? true : false} type= "file" id= "profile" hidden name= "profile" 
                                                onChange={(e)=>PhotoLoader(e, pinfo, tool_state, ps )}
                                                />
                                                <label htmlFor="profile">
                                                    <Box borderRadius="15px" bgcolor="#ffffff" pt={.9} px={1} width="100%" height="100%" sx={{opacity:0.8}}>
                                                        <Camera/>
                                                    </Box>
                                                </label>
                                            </>
                                        } */}
                                        </Box>
                                    </Box>
                                </Box>
                                <Box display="flex" flexDirection="column" alignItems="flex-start" height="20%" pt={3} >
                                    <Box color="white" fontSize="24px" fontWeight="600">
                                        {pinfo.first_name} {pinfo.middle_name} {pinfo.last_name} {pinfo.suffix} 
                                    </Box> 
                                    <Box color="white" fontSize="16px">
                                        {tool_state.__SESSION.data.uaccess[0].role_name}
                                    </Box> 
                                </Box> 
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* <Box textAlign="center" pr={1} mb="30px" position="relative" top="-345px" mt="1px" display="flex" justifyContent="flex-end">
                <Box position="relative" top="280px" mr={4}>
                    <input accept="image/*" 
                        disabled={ps.isLoader.data.status ? true : false} 
                        type= "file" id= "cover" hidden name="cover" 
                        onChange={(e)=>PhotoLoader(e, pinfo, tool_state, ps)}
                    />
                    <Box>
                        <label htmlFor= "cover">
                            <Box display="flex" justifyContent="center" alignItems="center" className="btn-cover" >
                                <Box fontSize="14px" mr="10px">Set Cover Photo </Box>
                                <img src={Addphoto} alt="icon" srcSet={Addphoto}  height="20px" width="20px" color="#fff" />
                            </Box> 
                        </label>
                    </Box>
                </Box>
            </Box> */}
        </Container>
    )
}